import {
  Component,
  ContentChild,
  HostBinding,
  Input,
  TemplateRef,
} from '@angular/core'

@Component({
  selector: 'app-tab',
  templateUrl: './tab.component.html',
  styleUrls: ['./tab.component.css'],
})
export class TabComponent {
  @Input() name!: string
  @Input() id!: any
  @Input() active: boolean = false

  @HostBinding('class.active') get isActive() {
    return this.active
  }
}
